module.exports = __webpack_public_path__ + "static/media/setting-centres.c4048faa.jpg";